// @LTG-ID: data-featured-journals
// @STATUS: BUILT @SHARED
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-020, source Journals.html lines 207-242 (editor's-picks trio)
// @CHANGED: 2026-02 session_003 (CHG-0049)
// @OWNER: web
//
// Editor's-picks trio surfaced on the landing page JournalsSection (F-020). The
// source has TWO journals concepts: (a) a simpler 3-tile data array in
// `Landing Page.html` line 2857 with {cat, title, meta, swatch, href} shape, and
// (b) the richer "Editor's picks" trio in `Journals.html` line 213 with the
// {tag, title, deck, readTime, status} shape that exposes Published vs Preview
// status and a primary (navy, larger) tile. ORCH-0040 directed us to surface (b)
// on the landing page rather than (a), so the JournalsSection composition is
// hybrid: outer header + closing band from Landing Page, inner trio from Journals.html.
// This is logged as ADR-012 D8 in `10_DECISIONS.md`.
//
// Targets:
//   - 2 published deep-dives → /journals/<slug> route (P3 still renders placeholder
//     so the route exists, click resolves cleanly).
//   - 1 preview brief → /journals#brief-13 fragment on the same route.
// All three links are INTERNAL (no `app.letstalkgrowth.com`); per ADR-008, internal anchors
// stay bare `<a>` tags — `<ExternalCTA>` is only for `app.letstalkgrowth.com` CRM links.

export const FEATURED_JOURNALS = [
    {
        // CHG-0104 · updated to point at the new-value-drivers pillar essay
        // (was Brief 01 hand-JSX). Deck pulled from the CHG-0102 manifest,
        // stable copy chosen to fit the landing-page tile shape.
        tag: "Value Drivers · Pillar",
        title:
            "The Value Drivers That Determine What Buyers Will Pay for Your Business",
        deck:
            "The single biggest lever on business value is not revenue growth or margins. It is who owns the value—and whether it walks out the door when the seller leaves.",
        readTime: "5 min read",
        status: "published",
        href: "/journals/business-value-drivers",
        primary: true,
    },
    {
        // CHG-0104 · linkable-asset feature (from CHG-0102 tagging).
        tag: "Exit Planning · Linkable Asset",
        title:
            "What Percentage of Businesses Actually Sell? The Statistics Every Owner Should See",
        deck:
            "Industry research consistently indicates that only a minority of small businesses listed for sale actually close a transaction.",
        readTime: "3 min read",
        status: "published",
        href: "/journals/what-percentage-of-businesses-sell",
        primary: false,
    },
    {
        // CHG-0104 · linkable-asset feature (from CHG-0102 tagging).
        tag: "Exit Planning · Linkable Asset",
        title:
            "The Silver Tsunami: Baby Boomer Business Owners by the Numbers",
        deck:
            "Roughly 12 million businesses in the United States are owned by baby boomers, a demographic sitting on the largest concentration of privately-held business value in history.",
        readTime: "3 min read",
        status: "published",
        href: "/journals/silver-tsunami-business-statistics",
        primary: false,
    },
];
